<div *ngIf="!noServices; else showNoService" class="flex flex-col justify-items-center pt-20 pl-20 pr-20 pb-10 white-bg byob-my-services">
	<div class="flex-col mb-20" [ngClass]="{'sandbox-height': !enterpriseClient}">
		<div class="flex-row justify-items-center mat-headline-5 fw-700">{{ enterpriseClient? ("MY_SERVICES.TITLE" | transloco) : ("MY_SERVICES.MY_SANDBOX" | transloco) }}</div>
		<div *ngIf="enterpriseClient" class="flex justify-end mb-20 mt--40">
			<button class="white rounded" (click)="viewSandboxService('service')" [ngClass]="{'selected-filter': viewService}">{{ "MY_SERVICES.SERVICES" | transloco }}</button>
			<!-- <button class="white rounded ml-16" (click)="viewSandboxService('sandbox');" [ngClass]="{'selected-filter': viewSandbox}">{{ "MY_SERVICES.SANDBOXES" | transloco }}</button> -->
		</div>
            <div *ngIf="isSandbox === true && viewSandbox; else showSandbox" class="flex-row service-card-container overflow-y-auto">
				<app-byob-sandbox-card *ngFor="let sandboxInfo of sandboxInfos | slice:0:4" [sandboxInfo]="sandboxInfo">
				</app-byob-sandbox-card>
			</div>
			<ng-template #showSandbox>
				<div *ngIf="(isSandbox === false && viewSandbox) && isLoader === false" class="flex flex-col items-center">
					<img src="/assets/images/sandbox.png">
					<div class="mat-subtitle-2 mb-24 fw-400 mt-8">{{ "MY_SERVICES.NO_ACTIVE_SANDBOXES" | transloco }}</div>
					<button class="flex items-center mossgreen mr-12" (click)="goToCreateSandbox()" [disabled]="!hasCreateSandboxPermission">
						<mat-icon svgIcon="add" class="icon-md"></mat-icon>
						{{ 'BYOB_DASHBOARD.CREATE_SANDBOX' | transloco }}
					</button>
				</div>
			</ng-template>
		<div *ngIf="isLoader">
			<img src="/assets/images/icon_Microservices.svg" class="loadingimg">
			<mat-progress-bar mode="indeterminate" class="progressbar " ></mat-progress-bar> 
			<div class="loadingtxt fs-16 fw-500">{{viewService ? ('BYOB_DASHBOARD.LOADING_SERVICES'| transloco) : ('BYOB_DASHBOARD.LOADING_SANDBOX'| transloco) }}</div>
		</div> 
			<div *ngIf="isServices === true && serviceInfos?.length > 0 && viewService; else showNoService" class="flex-row service-card-container overflow-y-auto">
				<app-byob-service-card *ngFor="let serviceInfo of serviceInfos | slice:0:20" [serviceCardInfo]="serviceInfo">
				</app-byob-service-card>
			</div> 
			<ng-template #showNoService>
				<div *ngIf="(isServices === false && viewService) && isLoader === false" class="flex flex-col items-center">
					<img src="/assets/images/icon_Microservices.svg">
					<div class="mat-subtitle-2 mb-24 fw-400 mt-8">{{ "MY_SERVICES.NO_SERVICE" | transloco }}</div>
					<button *ngIf="permissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="flex items-center mossgreen mr-12" (click)="goToComposeService()">
						<mat-icon svgIcon="add" class="icon-md"></mat-icon>
						{{ 'BYOB_DASHBOARD.COMPOSE_SERVICE' | transloco }}
					</button>
				</div>
			</ng-template>
	</div>
	<!-- <div class="flex flex-row justify-end mt-30" [ngClass]="{'hidden':(viewService? !(serviceInfos?.length > 0 ): !(sandboxInfos?.length > 0)) }"> 
		<button class="flex items-center basic-button mat-subtitle-2 ml-auto fw-700 cursor-pointer mb-0 p-0" (click)="goToMyServices()">
			{{ viewService? ("MY_SERVICES.VIEW_MY_SERVICES" | transloco) : ("MY_SERVICES.VIEW_ALL_SANDBOX" | transloco) }}
			<mat-icon svgIcon="chevron_right" class="icon icon-sm ml-2 mt-4 cursor-pointer"></mat-icon>
		</button>
	</div> -->
</div>
<ng-template #showNoService>
	<div class="flex flex-col justify-center items-center pt-50 pl-20 pr-20 pb-50 white-bg byob-my-services">
		<div class="mat-subtitle-2 fw-400">{{ "MY_SERVICES.NO_SERVICE" | transloco }}</div>
	</div>
</ng-template>